package com.schoolconnect.app.feature.subjects

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.schoolconnect.app.designsystem.AppConfirmationDialogTone
import com.schoolconnect.app.designsystem.AppDialogActionStyle
import com.schoolconnect.app.designsystem.AppDialogBody
import com.schoolconnect.app.designsystem.AppDialogDateField
import com.schoolconnect.app.designsystem.AppDialogColors
import com.schoolconnect.app.designsystem.AppDialogDivider
import com.schoolconnect.app.designsystem.AppDialogErrorMessage
import com.schoolconnect.app.designsystem.AppDialogFieldColumn
import com.schoolconnect.app.designsystem.AppDialogFieldRow
import com.schoolconnect.app.designsystem.AppDialogResponsiveFieldColumns
import com.schoolconnect.app.designsystem.AppDialogFormGrid
import com.schoolconnect.app.designsystem.AppDialogFooter
import com.schoolconnect.app.designsystem.AppDialogFooterAction
import com.schoolconnect.app.designsystem.AppDialogHeader
import com.schoolconnect.app.designsystem.AppDialogScaffold
import com.schoolconnect.app.designsystem.AppDialogValidationSummary
import com.schoolconnect.app.designsystem.AppDialogSelectField
import com.schoolconnect.app.designsystem.AppDialogSize
import com.schoolconnect.app.designsystem.AppDialogTextField
import com.schoolconnect.app.designsystem.AppBackground
import com.schoolconnect.app.designsystem.AppBorder
import com.schoolconnect.app.designsystem.AppDanger
import com.schoolconnect.app.designsystem.AppDangerSoft
import com.schoolconnect.app.designsystem.AppInputBorder
import com.schoolconnect.app.designsystem.AppLine
import com.schoolconnect.app.designsystem.AppMuted
import com.schoolconnect.app.designsystem.AppPrimary
import com.schoolconnect.app.designsystem.AppPrimarySoft
import com.schoolconnect.app.designsystem.AppSecondaryBackground
import com.schoolconnect.app.designsystem.AppSurface
import com.schoolconnect.app.designsystem.AppSuccess
import com.schoolconnect.app.designsystem.AppSuccessSoft
import com.schoolconnect.app.designsystem.AppWarning
import com.schoolconnect.app.designsystem.AppWarningSoft
import com.schoolconnect.app.designsystem.AppConfirmationDialog
import com.schoolconnect.app.designsystem.list.AdminInfoBanner
import com.schoolconnect.app.designsystem.list.AdminListDefaults
import com.schoolconnect.app.designsystem.list.AdminListEmptyState
import com.schoolconnect.app.designsystem.list.AdminListHeaderColumn
import com.schoolconnect.app.designsystem.list.AdminListSortColumn
import com.schoolconnect.app.designsystem.list.AdminListSortHeaderRow
import com.schoolconnect.app.designsystem.list.AdminListRowActionBar
import com.schoolconnect.app.designsystem.list.AdminListTableBody
import com.schoolconnect.app.designsystem.list.AdminListTableBodyText
import com.schoolconnect.app.designsystem.list.AdminListTypography
import com.schoolconnect.app.designsystem.list.AdminStatusChip
import com.schoolconnect.app.designsystem.list.AdminStandardRowActionMenu
import com.schoolconnect.app.designsystem.list.onViewDoubleClick
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.calendar
import ischoolconnect.sharedui.generated.resources.filter
import ischoolconnect.sharedui.generated.resources.close_x
import ischoolconnect.sharedui.generated.resources.document
import ischoolconnect.sharedui.generated.resources.more_vertical
import ischoolconnect.sharedui.generated.resources.user
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

internal val SubjectsBackground = AppSecondaryBackground
internal val SubjectsSurface = AppSurface
internal val SubjectsBorder = AppBorder
internal val SubjectsLine = AppLine
internal val SubjectsNavy = Color(0xFF09134A)
internal val SubjectsMuted = AppMuted
internal val SubjectsBlue = AppPrimary
internal val SubjectsBlueSoft = AppPrimarySoft
internal val SubjectsGreen = AppSuccess
internal val SubjectsGreenSoft = AppSuccessSoft
internal val SubjectsRed = AppDanger
internal val SubjectsRedSoft = AppDangerSoft
internal val SubjectsOrange = AppWarning
internal val SubjectsOrangeSoft = AppWarningSoft
internal val SubjectsPurple = Color(0xFF7C3AED)
internal val SubjectsPurpleSoft = Color(0xFFF0E8FF)
internal val SubjectsPink = Color(0xFFD84BCB)
internal val SubjectsPinkSoft = Color(0xFFFCE8FB)
internal val SubjectsInputBorder = AppInputBorder

private const val SubjectCodeColumnWeight = 0.15f
private const val SubjectNameColumnWeight = 0.33f
private const val SubjectCategoryColumnWeight = 0.24f
private const val SubjectActionsColumnWeight = 0.28f

private val SubjectsDialogColors = com.schoolconnect.app.designsystem.AppDialogDefaultColors


@Composable
internal fun SubjectsBanner(
    message: String,
    isError: Boolean,
    onDismiss: () -> Unit
) {
    val background = if (isError) SubjectsRedSoft else Color(0xFFEFF4FF)
    val content = if (isError) SubjectsRed else SubjectsBlue
    AdminInfoBanner(
        message = message,
        onDismiss = onDismiss,
        backgroundColor = background,
        borderColor = if (isError) SubjectsRedSoft else SubjectsBlueSoft,
        contentColor = content,
        accentColor = content,
        isError = isError
    )
}

@Composable
internal fun SubjectsHeaderRow(
    sortField: SubjectsSortField,
    sortAscending: Boolean,
    onSortChanged: (SubjectsSortField) -> Unit
) {
    AdminListSortHeaderRow(
        columns = listOf(
            AdminListSortColumn(
                label = "Subject Code",
                weight = SubjectCodeColumnWeight,
                selected = sortField == SubjectsSortField.CODE,
                ascending = sortAscending,
                onClick = { onSortChanged(SubjectsSortField.CODE) }
            ),
            AdminListSortColumn(
                label = "Subject Name",
                weight = SubjectNameColumnWeight,
                selected = sortField == SubjectsSortField.NAME,
                ascending = sortAscending,
                onClick = { onSortChanged(SubjectsSortField.NAME) }
            ),
            AdminListSortColumn(
                label = "Category",
                weight = SubjectCategoryColumnWeight,
                selected = sortField == SubjectsSortField.CATEGORY,
                ascending = sortAscending,
                onClick = { onSortChanged(SubjectsSortField.CATEGORY) }
            ),
        ),
        actionsLabel = "Actions",
        actionsWeight = SubjectActionsColumnWeight,
        labelColor = SubjectsNavy,
        selectedColor = SubjectsBlue,
        unselectedColor = SubjectsMuted,
        actionsAlignment = Alignment.Center
    )
}

@Composable
internal fun SubjectsTableBody(
    items: List<SubjectRowUi>,
    openActionMenuSubjectId: String?,
    onToggleActionMenu: (String) -> Unit,
    onCloseActionMenu: (String) -> Unit,
    onViewSubject: (String) -> Unit,
    onEditSubject: (String) -> Unit,
    onDeleteSubject: (String) -> Unit
) {
    if (items.isEmpty()) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .padding(28.dp),
            contentAlignment = Alignment.Center
        ) {
            AdminListEmptyState(
                title = "No subjects found",
                subtitle = "Try changing the search or filters."
            )
        }
        return
    }

    AdminListTableBody(items = items, key = { it.id }, modifier = Modifier.fillMaxSize()) { subject ->
        SubjectsTableRow(
            subject = subject,
            isMenuOpen = openActionMenuSubjectId == subject.id,
            onMenuToggle = { onToggleActionMenu(subject.id) },
            onMenuDismiss = { onCloseActionMenu(subject.id) },
            onView = { onViewSubject(subject.id) },
            onEdit = { onEditSubject(subject.id) },
            onDelete = { onDeleteSubject(subject.id) }
        )
    }
}

@Composable
private fun SubjectsTableRow(
    subject: SubjectRowUi,
    isMenuOpen: Boolean,
    onMenuToggle: () -> Unit,
    onMenuDismiss: () -> Unit,
    onView: () -> Unit,
    onEdit: () -> Unit,
    onDelete: () -> Unit
) {
    Column(modifier = Modifier.fillMaxWidth()) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .onViewDoubleClick(onView)
                .heightIn(min = 52.dp)
                .padding(horizontal = 24.dp, vertical = 12.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            AdminListTableBodyText(
                text = subject.code,
                modifier = Modifier.weight(SubjectCodeColumnWeight),
                color = SubjectsNavy,
                fontWeight = AdminListTypography.TableBodyWeightStrong
            )
            AdminListTableBodyText(
                text = subject.name,
                modifier = Modifier.weight(SubjectNameColumnWeight),
                color = SubjectsNavy,
                fontWeight = FontWeight.Medium
            )
            Row(
                modifier = Modifier.weight(SubjectCategoryColumnWeight),
                verticalAlignment = Alignment.CenterVertically
            ) {
                SubjectCategoryChip(category = subject.category)
            }
            Box(modifier = Modifier.weight(SubjectActionsColumnWeight), contentAlignment = Alignment.Center) {
                AdminListRowActionBar(
                        isActive = subject.status == SubjectStatusUi.ACTIVE,
                        expanded = isMenuOpen,
                        onExpandedChange = { onMenuToggle() },
                        onDismissRequest = onMenuDismiss,
                        onView = onView,
                        onEdit = onEdit,
                        onToggleStatus = null,
                        onDelete = onDelete,
                        width = 190.dp,
                        surfaceColor = AdminListDefaults.Surface,
                        borderColor = AdminListDefaults.Border
                )
            }
        }
        HorizontalDivider(color = SubjectsLine)
    }
}

@Composable
internal fun SubjectCategoryChip(category: String) {
    AdminListTableBodyText(text = categoryLabel(category))
}

@Composable
internal fun SubjectStatusChip(status: SubjectStatusUi) {
    val fg = when (status) {
        SubjectStatusUi.ACTIVE -> SubjectsGreen
        SubjectStatusUi.INACTIVE -> SubjectsRed
    }
    AdminListTableBodyText(
        text = status.label,
        color = fg
    )
}

@Composable
internal fun SubjectDetailsDialog(
    subject: SubjectRowUi,
    onDismiss: () -> Unit
) {
    AppDialogScaffold(
        onDismiss = onDismiss,
        size = AppDialogSize.Wide,
        colors = SubjectsDialogColors,
        maxDialogHeight = 940.dp
    ) {
        Column(modifier = Modifier.fillMaxWidth()) {
            AppDialogHeader(
                title = "View Subject",
                subtitle = "",
                onClose = onDismiss,
                colors = SubjectsDialogColors,
                icon = null
            )
            AppDialogDivider(colors = SubjectsDialogColors)
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 28.dp, vertical = 24.dp),
                verticalArrangement = Arrangement.spacedBy(18.dp)
            ) {
                Card(
                    modifier = Modifier.fillMaxWidth(),
                    colors = CardDefaults.cardColors(containerColor = Color(0xFFF9FBFF)),
                    border = androidx.compose.foundation.BorderStroke(1.dp, SubjectsBorder),
                    shape = RoundedCornerShape(10.dp)
                ) {
                    Column(
                        modifier = Modifier.padding(horizontal = 16.dp, vertical = 14.dp),
                        verticalArrangement = Arrangement.spacedBy(12.dp)
                    ) {
                        BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
                            if (maxWidth > 500.dp) {
                                Row(
                                    modifier = Modifier.fillMaxWidth(),
                                    horizontalArrangement = Arrangement.spacedBy(24.dp)
                                ) {
                                    SubjectMetaTile(
                                        title = "Created By",
                                        value = subject.createdBy,
                                        icon = Res.drawable.user,
                                        modifier = Modifier.weight(1f)
                                    )
                                    SubjectMetaTile(
                                        title = "Updated By",
                                        value = subject.updatedBy,
                                        icon = Res.drawable.user,
                                        modifier = Modifier.weight(1f)
                                    )
                                    SubjectMetaTile(
                                        title = "Created Date",
                                        value = subject.createdAt,
                                        icon = Res.drawable.calendar,
                                        modifier = Modifier.weight(1f)
                                    )
                                    SubjectMetaTile(
                                        title = "Last Updated",
                                        value = subject.updatedAt,
                                        icon = Res.drawable.calendar,
                                        modifier = Modifier.weight(1f)
                                    )
                                }
                            } else {
                                Column(verticalArrangement = Arrangement.spacedBy(10.dp)) {
                                    SubjectMetaTile(
                                        title = "Created By",
                                        value = subject.createdBy,
                                        icon = Res.drawable.user
                                    )
                                    SubjectMetaTile(
                                        title = "Updated By",
                                        value = subject.updatedBy,
                                        icon = Res.drawable.user
                                    )
                                    SubjectMetaTile(
                                        title = "Created Date",
                                        value = subject.createdAt,
                                        icon = Res.drawable.calendar
                                    )
                                    SubjectMetaTile(
                                        title = "Last Updated",
                                        value = subject.updatedAt,
                                        icon = Res.drawable.calendar
                                    )
                                }
                            }
                        }
                    }
                }

                Card(
                    modifier = Modifier.fillMaxWidth(),
                    colors = CardDefaults.cardColors(containerColor = SubjectsSurface),
                    border = androidx.compose.foundation.BorderStroke(1.dp, SubjectsBorder),
                    shape = RoundedCornerShape(10.dp)
                ) {
                    Column(modifier = Modifier.fillMaxWidth()) {
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(horizontal = 22.dp, vertical = 18.dp),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.spacedBy(14.dp)
                        ) {
                            Icon(
                                painter = painterResource(Res.drawable.document),
                                contentDescription = null,
                                tint = SubjectsBlue,
                                modifier = Modifier.size(28.dp)
                            )
                            Text(
                                text = "Subject Information",
                                color = SubjectsBlue,
                                fontSize = 15.sp,
                                fontWeight = FontWeight.ExtraBold
                            )
                        }
                        AppDialogDivider(colors = SubjectsDialogColors)
                        Column(
                            modifier = Modifier
                                .fillMaxWidth()
                    .padding(horizontal = 16.dp, vertical = 16.dp),
                            verticalArrangement = Arrangement.spacedBy(14.dp)
                        ) {
                            SubjectInfoRow("Subject Code", subject.code)
                            SubjectInfoRow("Subject Name", subject.name)
                            SubjectInfoRow("Category", "") {
                                SubjectCategoryChip(category = subject.category)
                            }
                            SubjectInfoRow("Status", "") {
                                SubjectStatusChip(status = subject.status)
                            }
                        }
                    }
                }
            }
            AppDialogDivider(colors = SubjectsDialogColors)
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 28.dp, vertical = 18.dp),
                horizontalArrangement = Arrangement.End
            ) {
                OutlinedButton(
                    onClick = onDismiss,
                    modifier = Modifier.height(48.dp),
                    shape = RoundedCornerShape(8.dp),
                    border = androidx.compose.foundation.BorderStroke(1.dp, SubjectsBorder)
                ) {
                    Text(
                        text = "Close",
                        color = SubjectsBlue,
                        fontSize = 15.sp,
                        fontWeight = FontWeight.ExtraBold
                    )
                }
            }
        }
    }
}

@Composable
internal fun SubjectEditorDialog(
    draft: SubjectEditorDraft,
    categoryOptions: List<String>,
    isEditing: Boolean,
    isSaving: Boolean,
    apiError: String = "",
    onDismiss: () -> Unit,
    onSave: () -> Unit,
    onCodeChanged: (String) -> Unit,
    onNameChanged: (String) -> Unit,
    onCategoryChanged: (String) -> Unit
) {
    val title = if (isEditing) "Edit Subject" else "Add Subject"
    val subtitle = if (isEditing) "Update the subject details below." else "Enter the subject details to create a new subject record."
    val saveLabel = if (isEditing) "Save" else "Add"
    var hasSubmitted by remember(draft.id) { mutableStateOf(draft.id.isNotBlank()) }
    val validation = remember(hasSubmitted, draft.code, draft.name, draft.category) {
        if (hasSubmitted) validateSubjectEditor(draft) else SubjectEditorValidationErrors()
    }

    AppDialogScaffold(
        onDismiss = { if (!isSaving) onDismiss() },
        dismissOnClickOutside = false,
        size = AppDialogSize.Standard,
        colors = SubjectsDialogColors,
        maxDialogHeight = 920.dp,
        isLoading = isSaving,
        loadingTitle = if (isEditing) "Saving subject" else "Adding subject"
    ) {
        Column(modifier = Modifier.fillMaxWidth()) {
            AppDialogHeader(
                title = title,
                subtitle = subtitle,
                onClose = { if (!isSaving) onDismiss() },
                colors = SubjectsDialogColors,
                icon = null
            )
            AppDialogValidationSummary(
                errors = listOf(validation.code, validation.name, validation.category),
                colors = SubjectsDialogColors,
                modifier = Modifier.padding(horizontal = 28.dp, vertical = 12.dp)
            )
            AppDialogErrorMessage(
                message = apiError,
                colors = SubjectsDialogColors,
                modifier = Modifier.padding(horizontal = 28.dp, vertical = 12.dp)
            )
            AppDialogDivider(colors = SubjectsDialogColors)
            AppDialogFormGrid(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 28.dp, vertical = 24.dp)
            ) {
                val compact = it
                AppDialogResponsiveFieldColumns(
                    compact = compact,
                    compactContent = {
                            BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
                                val stackCodeAndName = maxWidth < 300.dp
                                if (stackCodeAndName) {
                                    SubjectCodeField(
                                        value = draft.code,
                                        error = validation.code,
                                        onValueChange = onCodeChanged
                                    )
                                    SubjectNameField(
                                        value = draft.name,
                                        error = validation.name,
                                        onValueChange = onNameChanged
                                    )
                                } else {
                                    AppDialogFieldRow(
                                        modifier = Modifier.fillMaxWidth(),
                                        spacing = 16.dp
                                    ) {
                                        SubjectCodeField(
                                            modifier = Modifier.weight(1f),
                                            value = draft.code,
                                            error = validation.code,
                                            onValueChange = onCodeChanged
                                        )
                                        SubjectNameField(
                                            modifier = Modifier.weight(1f),
                                            value = draft.name,
                                            error = validation.name,
                                            onValueChange = onNameChanged
                                        )
                                    }
                                }
                            }
                            BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
                                SubjectCategoryField(
                                    value = draft.category,
                                    error = validation.category,
                                    categoryOptions = categoryOptions,
                                    onValueChange = onCategoryChanged
                                )
                            }
                    },
                    firstColumn = {
                        SubjectFormField(
                            label = "Subject Code",
                            required = true,
                            error = validation.code,
                            value = draft.code,
                            placeholder = "Enter subject code (e.g. MAT)",
                            helperText = "Max 10 characters, uppercase only.",
                            maxLength = SubjectCodeMaxLength,
                            onValueChange = onCodeChanged
                        )
                        SubjectFormField(
                            label = "Category",
                            required = true,
                            error = validation.category,
                            field = {
                                SubjectDropdownField(
                                    value = draft.category,
                                    placeholder = "Enter or Select Category",
                                    options = categoryOptions,
                                    onValueChange = onCategoryChanged,
                                    error = validation.category
                                )
                            }
                        )
                    },
                    secondColumn = {
                        SubjectFormField(
                            label = "Subject Name",
                            required = true,
                            error = validation.name,
                            value = draft.name,
                            placeholder = "Enter subject name (e.g. Mathematics)",
                            helperText = "",
                            onValueChange = onNameChanged
                        )
                    }
                )
            }
            AppDialogDivider(colors = SubjectsDialogColors)
            AppDialogFooter(
                actions = listOf(
                    AppDialogFooterAction(
                        label = "Cancel",
                        onClick = { if (!isSaving) onDismiss() },
                        style = AppDialogActionStyle.Secondary,
                        enabled = !isSaving,
                        width = 152.dp
                    ),
                    AppDialogFooterAction(
                        label = if (isSaving) {
                            if (isEditing) "Saving..." else "Adding..."
                        } else saveLabel,
                        onClick = {
                            if (!isSaving) {
                                hasSubmitted = true
                                if (!validateSubjectEditor(draft).hasAnyError) onSave()
                            }
                        },
                        style = AppDialogActionStyle.Primary,
                        enabled = !isSaving,
                        width = 152.dp
                    )
                ),
                colors = SubjectsDialogColors,
                horizontalArrangement = Arrangement.End
            )
        }
    }
}

@Composable
internal fun SubjectFilterDialog(
    draft: SubjectFilterCriteria,
    categoryOptions: List<String>,
    onDismiss: () -> Unit,
    onReset: () -> Unit,
    onApply: (SubjectFilterCriteria) -> Unit
) {
    var localDraft by remember(draft) { mutableStateOf(draft) }

    AppDialogScaffold(
        onDismiss = onDismiss,
        size = AppDialogSize.Wide,
        colors = SubjectsDialogColors,
        maxDialogHeight = 760.dp
    ) {
        Column(modifier = Modifier.fillMaxWidth()) {
            AppDialogHeader(
                title = "Filter Subjects",
                subtitle = "Narrow down the subject list.",
                onClose = onDismiss,
                colors = SubjectsDialogColors,
                icon = Res.drawable.filter,
                iconContentDescription = "Filter subjects"
            )
            AppDialogDivider(colors = SubjectsDialogColors)
            AppDialogBody(
                colors = SubjectsDialogColors,
                horizontalPadding = 28.dp,
                compactHorizontalPadding = 20.dp,
                verticalPadding = 24.dp
            ) { compact ->
                if (compact) {
                    Column(verticalArrangement = Arrangement.spacedBy(18.dp)) {
                        SubjectFilterTextFields(localDraft) { localDraft = it }
                        SubjectFilterCategoryDropdown(localDraft, categoryOptions) { localDraft = it }
                        SubjectFilterDates(localDraft) { localDraft = it }
                    }
                } else {
                    Column(verticalArrangement = Arrangement.spacedBy(28.dp)) {
                        AppDialogFieldRow(spacing = 28.dp) {
                            SubjectFilterField(label = "Subject Code", modifier = Modifier.weight(1f)) {
                                AppDialogTextField(
                                    value = localDraft.subjectCode,
                                    onValueChange = { localDraft = localDraft.copy(subjectCode = it) },
                                    placeholder = "Enter Subject Code",
                                    colors = SubjectsDialogColors
                                )
                            }
                            SubjectFilterField(label = "Subject Name", modifier = Modifier.weight(1f)) {
                                AppDialogTextField(
                                    value = localDraft.subjectName,
                                    onValueChange = { localDraft = localDraft.copy(subjectName = it) },
                                    placeholder = "Enter Subject Name",
                                    colors = SubjectsDialogColors
                                )
                            }
                        }
                        AppDialogFieldRow(spacing = 28.dp) {
                            SubjectFilterField("Category", modifier = Modifier.weight(1f)) {
                                SubjectDropdownField(
                                    value = localDraft.category,
                                    placeholder = "Select Category",
                                        options = categoryOptions,
                                    onValueChange = { localDraft = localDraft.copy(category = it) }
                                )
                            }
                        }
                        AppDialogFieldRow(spacing = 28.dp) {
                            SubjectFilterDateField("Created Date From", localDraft.createdFrom, Modifier.weight(1f)) {
                                localDraft = localDraft.copy(createdFrom = it)
                            }
                            SubjectFilterDateField("Created Date To", localDraft.createdTo, Modifier.weight(1f)) {
                                localDraft = localDraft.copy(createdTo = it)
                            }
                        }
                    }
                }
            }
            AppDialogDivider(colors = SubjectsDialogColors)
            AppDialogFooter(
                actions = listOf(
                    AppDialogFooterAction(
                        label = "Reset",
                        onClick = {
                            localDraft = SubjectFilterCriteria()
                            onReset()
                        },
                        style = AppDialogActionStyle.Secondary,
                        width = 188.dp
                    ),
                    AppDialogFooterAction(
                        label = "Cancel",
                        onClick = onDismiss,
                        style = AppDialogActionStyle.Secondary,
                        width = 204.dp
                    ),
                    AppDialogFooterAction(
                        label = "Apply",
                        onClick = { onApply(localDraft) },
                        style = AppDialogActionStyle.Primary,
                        width = 264.dp
                    )
                ),
                colors = SubjectsDialogColors,
                horizontalArrangement = Arrangement.End
            )
        }
    }
}

@Composable
private fun SubjectFilterTextFields(
    draft: SubjectFilterCriteria,
    onChange: (SubjectFilterCriteria) -> Unit
) {
    SubjectFilterField("Subject Code") {
        AppDialogTextField(
            value = draft.subjectCode,
            onValueChange = { onChange(draft.copy(subjectCode = it)) },
            placeholder = "Enter Subject Code",
            colors = SubjectsDialogColors
        )
    }
    SubjectFilterField("Subject Name") {
        AppDialogTextField(
            value = draft.subjectName,
            onValueChange = { onChange(draft.copy(subjectName = it)) },
            placeholder = "Enter Subject Name",
            colors = SubjectsDialogColors
        )
    }
}

@Composable
private fun SubjectFilterCategoryDropdown(
    draft: SubjectFilterCriteria,
    categoryOptions: List<String>,
    onChange: (SubjectFilterCriteria) -> Unit
) {
    SubjectFilterField("Category") {
        SubjectDropdownField(
            value = draft.category,
            placeholder = "Select Category",
            options = categoryOptions,
            onValueChange = { onChange(draft.copy(category = it)) }
        )
    }
}

@Composable
private fun SubjectFilterDates(
    draft: SubjectFilterCriteria,
    onChange: (SubjectFilterCriteria) -> Unit
) {
    SubjectFilterDateField("Created Date From", draft.createdFrom) { onChange(draft.copy(createdFrom = it)) }
    SubjectFilterDateField("Created Date To", draft.createdTo) { onChange(draft.copy(createdTo = it)) }
}

@Composable
private fun SubjectFilterDateField(
    label: String,
    value: String,
    modifier: Modifier = Modifier,
    onValueChange: (String) -> Unit
) {
    SubjectFilterField(
        label = label,
        modifier = modifier
    ) {
        AppDialogDateField(
            value = value,
            onValueChange = onValueChange,
            placeholder = "DD MMM YYYY",
            colors = SubjectsDialogColors
        )
    }
}

@Composable
private fun SubjectMetaTile(
    icon: DrawableResource,
    title: String,
    value: String,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.Top,
        horizontalArrangement = Arrangement.spacedBy(10.dp)
    ) {
        Box(
            modifier = Modifier
                .size(38.dp)
                .background(SubjectsBlueSoft, RoundedCornerShape(50)),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                painter = painterResource(icon),
                contentDescription = null,
                tint = SubjectsBlue,
                modifier = Modifier.size(18.dp)
            )
        }
        Column(verticalArrangement = Arrangement.spacedBy(2.dp)) {
            Text(
                text = title,
                color = SubjectsMuted,
                fontSize = 12.sp,
                fontWeight = FontWeight.Medium,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            Text(
                text = value.ifBlank { "-" },
                color = SubjectsNavy,
                fontSize = 14.sp,
                fontWeight = FontWeight.ExtraBold,
                maxLines = 2,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}

@Composable
private fun SubjectInfoRow(
    label: String,
    value: String,
    valueContent: (@Composable RowScope.() -> Unit)? = null
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(16.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = label,
            modifier = Modifier.width(160.dp),
            color = SubjectsMuted,
            fontSize = 15.sp,
            fontWeight = FontWeight.ExtraBold
        )
        Text(
            text = ":",
            modifier = Modifier.width(18.dp),
            color = SubjectsMuted,
            fontSize = 15.sp,
            fontWeight = FontWeight.ExtraBold
        )
        if (valueContent != null) {
            Row(content = valueContent)
        } else {
            Text(
                text = value.ifBlank { "-" },
                modifier = Modifier.weight(1f),
                color = SubjectsNavy,
                fontSize = 15.sp,
                fontWeight = FontWeight.ExtraBold
            )
        }
    }
}

@Composable
private fun SubjectFormField(
    label: String,
    modifier: Modifier = Modifier,
    required: Boolean = false,
    error: String = "",
    value: String = "",
    placeholder: String = "",
    helperText: String = "",
    maxLength: Int? = null,
    onValueChange: ((String) -> Unit)? = null,
    field: (@Composable () -> Unit)? = null
) {
    AppDialogFieldColumn(
        label = label,
        modifier = modifier,
        required = required,
        error = error,
        colors = SubjectsDialogColors,
        field = {
            Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
                if (field != null) {
                    field()
                } else {
                    AppDialogTextField(
                        value = value,
                        onValueChange = onValueChange ?: {},
                        placeholder = placeholder,
                        maxLength = maxLength,
                        colors = SubjectsDialogColors,
                        error = error
                    )
                }
                if (helperText.isNotBlank()) {
                    Text(
                        text = helperText,
                        color = SubjectsMuted,
                        fontSize = 12.sp,
                        fontWeight = FontWeight.Normal
                    )
                }
            }
        }
    )
}

@Composable
private fun SubjectCategoryField(
    modifier: Modifier = Modifier,
    value: String,
    error: String,
    categoryOptions: List<String>,
    onValueChange: (String) -> Unit
) {
    SubjectFormField(
        modifier = modifier,
        label = "Category",
        required = true,
        error = error,
        field = {
            SubjectDropdownField(
                value = value,
                placeholder = "Enter or Select Category",
                options = categoryOptions,
                onValueChange = onValueChange,
                error = error
            )
        }
    )
}

@Composable
private fun SubjectCodeField(
    modifier: Modifier = Modifier,
    value: String,
    error: String,
    onValueChange: (String) -> Unit
) {
    SubjectFormField(
        modifier = modifier,
        label = "Subject Code",
        required = true,
        error = error,
        value = value,
        placeholder = "Enter subject code (e.g. MAT)",
        helperText = "Max 10 characters, uppercase only.",
        maxLength = SubjectCodeMaxLength,
        onValueChange = onValueChange
    )
}

@Composable
private fun SubjectNameField(
    modifier: Modifier = Modifier,
    value: String,
    error: String,
    onValueChange: (String) -> Unit
) {
    SubjectFormField(
        modifier = modifier,
        label = "Subject Name",
        required = true,
        error = error,
        value = value,
        placeholder = "Enter subject name (e.g. Mathematics)",
        onValueChange = onValueChange
    )
}

@Composable
private fun SubjectDropdownField(
    value: String,
    placeholder: String,
    options: List<String>,
    onValueChange: (String) -> Unit,
    error: String = ""
) {
    var expanded by remember { mutableStateOf(false) }
    AppDialogSelectField(
        value = value,
        placeholder = placeholder,
        expanded = expanded,
        options = options,
        onToggleExpanded = { expanded = true },
        onDismissExpanded = { expanded = false },
        onSelected = onValueChange,
        colors = SubjectsDialogColors,
        error = error
    )
}

@Composable
private fun SubjectFilterField(
    label: String,
    modifier: Modifier = Modifier,
    field: @Composable () -> Unit
) {
    AppDialogFieldColumn(
        label = label,
        modifier = modifier,
        colors = SubjectsDialogColors,
        field = field
    )
}

private fun categoryLabel(category: String): String = subjectCategoryLabel(category)

internal fun visibleRangeText(start: Int, end: Int, total: Int): String =
    "Showing ${start.coerceAtLeast(0)} to ${end.coerceAtLeast(0)} of $total subjects"

internal fun subjectsTableShimmerColumns(): List<AdminListHeaderColumn> = listOf(
    AdminListHeaderColumn(label = "Subject Code", weight = SubjectCodeColumnWeight),
    AdminListHeaderColumn(label = "Subject Name", weight = SubjectNameColumnWeight),
    AdminListHeaderColumn(label = "Category", weight = SubjectCategoryColumnWeight),
    AdminListHeaderColumn(label = "Actions", weight = SubjectActionsColumnWeight, alignCenter = true)
)
